import React from 'react';
import { Link } from 'react-router-dom';

const CodeList = props => {
    if (!props.codes) {
        return (
            <div className='broad'>Loading...</div>
        );
    }

    if (props.codes.length === 0) {
        return (
            <div className='empty'>
                No codes...
      </div>
        );
    }

    return (
        <div>
            <table className="accountsTable">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Code</th>
                        <th>Sent Time</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.codes.map(item => {
                            return (
                                <tr key={item.modified}>
                                    <td>{item.type}</td>
                                    <td>{item.code}</td>
                                    <td>{item.modified}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default CodeList;



// WEBPACK FOOTER //
// ./src/components/widgets/CodeList.js